export const USE_LOCAL_STORAGE = true; // process.env.NODE_ENV !== "development";
export const NAME_LOCAL_STORAGE_KEY = "user_info";
export const BASE_URL = process.env.BASE_URL || "https://training.outlast.com/";
export const PAGE_TRANSITION_TIMEOUT = 0;
